// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".digital-earth[data-v-1dc1a5cd]{position:relative}.digital-earth .news-warp[data-v-1dc1a5cd]{position:absolute;top:20px;left:20px;color:#fff;z-index:1}.digital-earth .config-button[data-v-1dc1a5cd]{position:absolute;top:60px;left:20px;color:#fff;z-index:1}", ""]);
// Exports
module.exports = exports;
